import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios';
import { BASE_URL_SANDBOX, GET_ALL_COUPON_LIST } from "../../../Constants/Config"

const initialState = {
    loading: false,
    couponListData: [],
    error: '',
    requestKey: '',
    activeRequestId: null,
    activeRequestKey: '',
}

export const createCouponListRequestKey = (data) => {
    const merchantId = data?.merchant_id;
    if (merchantId === null || merchantId === undefined) return '';

    const normalizedMerchantId = String(merchantId).trim().toUpperCase();
    return normalizedMerchantId ? `merchant:${normalizedMerchantId}` : '';
}

// Generate pening , fulfilled and rejected action type
export const fetchCouponListData = createAsyncThunk('couponList/fetchCouponListData', async (data) => {
    try {
        const response = await axios.post(BASE_URL_SANDBOX + GET_ALL_COUPON_LIST, data, { headers: { "Content-Type": "multipart/form-data" } })
        if (response.data.status === 200) {
            const myresponse = {
                result: response.data.result,
                message: ""
            }
            return myresponse
        }
        else if (response.data.status === 400) {
            const myresponse = {
                result: "",
                message: response.data.message
            }
            return myresponse
        }
    } catch (error) {
        throw new Error(error.response.data.message);
    }
})



const couponListSlice = createSlice({
    name: 'couponList',
    initialState,
    // reducers: {
        
    // },

    extraReducers: (builder) => {
        builder.addCase(fetchCouponListData.pending, (state, action) => {
            const requestId = action.meta?.requestId;
            if (!requestId) return;

            const requestKey = createCouponListRequestKey(action.meta?.arg);
            if (state.requestKey !== requestKey) {
                state.couponListData = [];
                state.requestKey = '';
            }
            state.loading = true;
            state.error = '';
            state.activeRequestId = requestId;
            state.activeRequestKey = requestKey;
        })
        builder.addCase(fetchCouponListData.fulfilled, (state, action) => {
            const requestKey = createCouponListRequestKey(action.meta?.arg);
            if (
                action.meta?.requestId !== state.activeRequestId ||
                requestKey !== state.activeRequestKey
            ) {
                return;
            }

            state.loading = false;
            state.couponListData = action.payload;
            state.error = '';
            state.requestKey = requestKey;
            state.activeRequestId = null;
            state.activeRequestKey = '';
        })
        builder.addCase(fetchCouponListData.rejected, (state, action) => {
            const requestKey = createCouponListRequestKey(action.meta?.arg);
            if (
                action.meta?.requestId !== state.activeRequestId ||
                requestKey !== state.activeRequestKey
            ) {
                return;
            }

            state.loading = false;
            state.couponListData = {};
            state.error = action.error?.message || 'Unable to load coupons';
            state.requestKey = '';
            state.activeRequestId = null;
            state.activeRequestKey = '';
        })


    }
})


// export const { removeCoupon } = couponListSlice.actions;
export default couponListSlice.reducer
